<template>
  <div>
    <span class="hidden-sm-and-down">
      <v-data-table :headers="headers"  hide-actions :items="buyOrders" item-key="id+p" class="elevation-0" style="overflow: auto; height:87vh;" >
        <template v-slot:items="props">
          
          <v-tooltip top>
              <template v-slot:activator="{ on }">
          <tr v-on="on" @click="handleClickBid(props.item.bidPrice,props.item.bidAmount,props.item.bidTotal) " @mouseover="hover(props.item.bidPrice) " class="text-xs-left  green--text font-weight-bold">
            <td class="font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:1}).format(props.item.bidTotal) }}</td>
            <td class="font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:7}).format(props.item.bidAmount)}}</td>
            <td class="font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.bidPrice)  }}</td>
          </tr>
              </template>
              <span>{{price}} </span>
            </v-tooltip>
          
        </template>
      </v-data-table>
    </span>
    

    <span class="hidden-md-and-up">
      <v-data-table :headers="headsm" hide-actions :items="buyOrders" item-key="id+i" class="elevation-0" style="overflow: auto; height:50vh;">
        <template v-slot:items="props">
          
          <v-tooltip top>
              <template v-slot:activator="{ on }">
                <tr v-on="on" @click="handleClickBid(props.item.bidPrice,props.item.bidAmount,props.item.bidTotal)" @mouseover="hover(props.item.bidPrice) " class="text-xs-left green--text">
                    <td class="font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.bidPrice)}}</td>
                    <td class="font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:7}).format(props.item.bidAmount) }}</td>
                    <td class="font-weight-bold">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:1}).format(props.item.bidTotal) }}</td>
                  </tr>
              </template>
              <span>{{price}} </span>
            </v-tooltip>
          
          
        </template>
      </v-data-table>
    </span>
  </div>
</template>

<script>
import { mapActions,mapState } from "vuex";
import axios from "axios";

export default {
  props: {
    asset: {
      type: String,
    },
    currency:{
      type:String
    },
    second:{
      type:String
    }
  },
  data() {
    return {
      headers: [
        { text: "Total", align: "left", sortable: false },
        { text: "Quantité", align: "left", sortable: false },
        { text: "Prix", sortable: false }
      ],

      headsm: [
        { text: "Prix", sortable: false },
        { text: "Quantité", align: "left", sortable: false },
        { text: "Total", align: "left", sortable: false }
      ],
      btcPrice:null,
      price:null,

    };
  },
  mounted() {
   this.someAction()
  },

  computed: {
    ...mapState({
      buyOrders(state,getters) {
        return getters["order/"+this.currency+this.second+"_buyOrders" ]
    },
    }),
    
  },
  methods: {
    // hover(bidPrice){
    //   axios.get('https://us-central1-hiropay-6c8a4.cloudfunctions.net/app/btc_price').then((res)=>{
    //     console.log(res);
    //     let btcPrice = Number(res.data.btcPrice);
    //     if (typeof bidPrice == 'number') {
    //          this.price=(bidPrice / btcPrice-0.01).toFixed(2);
    //      }
    //   });
    // },

     hover(bidPrice){
      axios.get('https://www.blockchain.com/ticker').then((res)=>{
        
        let btcPrice = Number(res.data.USD.last);
        if (typeof bidPrice == 'number') {
             this.price=(bidPrice / btcPrice-0.01).toFixed(2);
         }
      });
      // axios.get('https://api.coingecko.com/api/v3/coins/bitcoin').then(res=>{
      //   let {data} = res
      //   console.log(data.market_data.current_price.usd);
      //   let btcPrice = Number(data.market_data.current_price.usd);
      //   if (typeof bidPrice == 'number') {
      //        this.price=(bidPrice / btcPrice-0.01).toFixed(2);
      //    }
      // });
    },


    handleClickBid(bidPrice, bidAmount, bidTotal){
      this.$root.$emit('clickBid',bidPrice, bidAmount, bidTotal)
    },
      ...mapActions({
        someAction (dispatch) {
        return dispatch("order/bind_"+ this.currency+this.second+"_buyOrders")
      }
       })
  } 
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: red; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>
